module.exports = {"title":"จัดการ Display Schedule"}


//////////////////
// WEBPACK FOOTER
// ./src/language/th/controlDisplaySchedule.json
// module id = 1015
// module chunks = 10